import { render, staticRenderFns } from "./BCXNewStuffBanner.vue?vue&type=template&id=30729c34&scoped=true"
import script from "./BCXNewStuffBanner.vue?vue&type=script&lang=ts"
export * from "./BCXNewStuffBanner.vue?vue&type=script&lang=ts"
import style0 from "./BCXNewStuffBanner.vue?vue&type=style&index=0&id=30729c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30729c34",
  null
  
)

export default component.exports